import { render, staticRenderFns } from "./Сommunications.vue?vue&type=template&id=1210151e&"
import script from "./Сommunications.vue?vue&type=script&lang=js&"
export * from "./Сommunications.vue?vue&type=script&lang=js&"
import style0 from "./Сommunications.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports